module.exports = __webpack_public_path__ + "static/media/gifts.e7572bf9.svg";